export const courseList = [
  "SQL Course - University of Waterloo",
  "The Complete Javascript course - Udemy",
  "Complete React Developer - Udemy",
];

export const ubcProjectsList = [
  {
    title: "Cake Rush - Memory Game (CPSC 210)",
    githubLink: "https://github.com/ALagodzinska/CakeRush",
  },
  {
    title: "Game Server Playtime Prediction Model (DCSI 100)",
  },
  {
    title: "Major Course Planner (HackCamp 2025)",
  },
];

export const selfLearningProjectList = [
  {
    title: "Crown Clothing Website",
    websiteLink: "https://stacy-clothing.netlify.app/",
    githubLink: "https://github.com/ALagodzinska/Crown-Clothing",
  },
  {
    title: "Forkify Recipe App",
    websiteLink: "https://forkify-recipes-stacy.netlify.app/",
    githubLink: "https://github.com/ALagodzinska/Forkify",
  },
  {
    title: "Mapty Workouts Tracking",
    websiteLink: "https://alagodzinska.github.io/MaptyApp/",
    githubLink: "https://github.com/ALagodzinska/MaptyApp",
  },
];

export const accentureInternshipProjects = [
  {
    title: "Conways Game Of Life",
    githubLink: "https://github.com/ALagodzinska/ConwaysGameOfLife",
  },
  {
    title: "Savanna Game",
    githubLink: "https://github.com/ALagodzinska/Savanna-Game",
  },
];

export const accentureBootcampProjects = [
  {
    title: "Hermes Chat App",
    githubLink: "https://github.com/ALagodzinska/ChatApp",
  },
];

export const sheGoesTechProjects = [
  {
    title: "Attendance Management Application",
    githubLink:
      "https://github.com/ALagodzinska/StudentsAttendanceManagementApp",
  },
];
